import moment from 'moment';
import _ from 'lodash';

export const createNonReactive = obj => JSON.parse(JSON.stringify(obj));

export const getError = (err) => {
  const errorMsg = err && err.response && err.response.data ? err.response.data.status.msg : err;
  return err.response ? errorMsg : 'Wystąpił nieoczekiwany błąd!';
};

export const parseDate = date => moment(date, 'YYYY-MM-DD').format('YYYY.MM.DD');

export const getMaxMin = dateArray => _.map(dateArray, date => moment(date));

export const isAfter = (start, end) => moment(start, 'YYYY-MM-DD').isAfter(end, 'YYYY-MM-DD');

export const isSame = (start, end) => moment(start, 'YYYY-MM-DD').isSame(end, 'YYYY-MM-DD');

export const getFilesRange = (range) => {
  const start = moment(range.min, 'YYYY-MM-DD');
  const end = moment(range.max, 'YYYY-MM-DD');
  const diffDays = end.diff(start, 'days');
  const rangeDays = [];
  let newDay = start;
  for (let i = 0; i <= diffDays; i += 1) {
    rangeDays.push(newDay.format('YYYY-MM-DD'));
    newDay = start.add(1, 'days');
  }
  return rangeDays;
};

export const getInflection = (count, singular, plural, genitive) => {
  const number = Math.abs(count);
  if (number === 1) return singular;
  const odd10 = number % 10;
  const odd100 = number % 100;
  if (odd10 > 4 || odd10 < 2 || (odd100 < 15 && odd100 > 11)) {
    return genitive;
  }
  return plural;
};

export const decodeUri = string => window.atob(string);

export const downloadInit = async (file) => {
  const elem = document.createElement('a');
  elem.download = file;
  elem.href = file;
  document.body.appendChild(elem);
  elem.click();
};

export const getFilenameExtension = (filename) => {
  const re = /(?:\.([^.]+))?$/;
  return re.exec(filename)[1];
};

export const getMimeTypeData = (mime, fullClassName = false) => {
  let mimeTypeData;
  switch (mime) {
    case 'pdf':
      mimeTypeData = {
        icon: 'fas fa-file-pdf',
        color: fullClassName ? 'red--text text--darken-2' : 'red darken-2',
      };
      break;
    case 'png':
      mimeTypeData = {
        icon: 'fas fa-file-image',
        color: fullClassName ? 'red--text' : 'red',
      };
      break;
    case 'jpg':
      mimeTypeData = {
        icon: 'fas fa-file-image',
        color: fullClassName ? 'red--text' : 'red',
      };
      break;
    case 'jpeg':
      mimeTypeData = {
        icon: 'fas fa-file-image',
        color: fullClassName ? 'red--text' : 'red',
      };
      break;
    case 'gif':
      mimeTypeData = {
        icon: 'fas fa-file-image',
        color: fullClassName ? 'amber--text' : 'amber',
      };
      break;
    case 'doc':
      mimeTypeData = {
        icon: 'fas fa-file-word',
        color: fullClassName ? 'blue--text' : 'blue',
      };
      break;
    case 'docx':
      mimeTypeData = {
        icon: 'fas fa-file-word',
        color: fullClassName ? 'blue--text' : 'blue',
      };
      break;
    case 'xls':
      mimeTypeData = {
        icon: 'fas fa-file-excel',
        color: fullClassName ? 'green--text' : 'green',
      };
      break;
    case 'xlsx':
      mimeTypeData = {
        icon: 'fas fa-file-excel',
        color: fullClassName ? 'green--text' : 'green',
      };
      break;
    case 'folder':
      mimeTypeData = {
        icon: 'folder',
        color: fullClassName ? 'primary--text' : 'primary',
      };
      break;
    default:
      mimeTypeData = {
        icon: 'fas fa-file',
        color: fullClassName ? 'light-blue--text' : 'light-blue',
      };
  }
  return mimeTypeData;
};

export const getPlural = (number, phrases) => {
  const n = parseInt(number, 10);
  let index = 0;
  if (n !== 1) {
    index = n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  }
  return typeof phrases[index] !== 'undefined' ? phrases[index].replace('%d', n) : '';
};
